import React from 'react';
import { useNavigate } from 'react-router-dom';


/**
 * TopBar component
 *
 * A slim bar at the very top of the page with a call to action. It prompts
 * visitors to book a session and links them to the contact section. You can
 * customise the message or hide this bar if you don't want a persistent CTA.
 */
const TopBar = () => {
  const navigate = useNavigate();

  return (
    <div className="top-bar">
      <span>Ready for your first session?</span>
      <button className="btn btn-primary" onClick={() => navigate('/book')}>Book Now</button>
    </div>
  );
};

export default TopBar;